import { render, staticRenderFns } from "./SlotPage.vue?vue&type=template&id=65c1cac8&scoped=true"
import script from "./SlotPage.vue?vue&type=script&lang=js"
export * from "./SlotPage.vue?vue&type=script&lang=js"
import style0 from "./SlotPage.vue?vue&type=style&index=0&id=65c1cac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c1cac8",
  null
  
)

export default component.exports